import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-slido',
  templateUrl: './slido.component.html',
  styleUrls: ['./slido.component.scss']
})
export class SlidoComponent implements OnInit {
  constructor() {}

  @Input() eventID: string;
  @Input() iframeUrl: string;

  url: string;

  ngOnInit(): void {
    if (this.iframeUrl) {
      this.url = this.iframeUrl;
    } else {
      this.url = 'https://app.sli.do/event/' + this.eventID;
    }
  }
}
